import { useRef, useEffect, useState } from "react";
import { motion, useAnimation, useMotionValue } from "framer-motion";

export default function ImageMarquee({ 
  images, 
  speed = 30, 
  direction = "left",
  className = "" 
}) {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }
    
    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div ref={containerRef} className={`w-100 overflow-hidden position-relative ${className}`} style={{ touchAction: "pan-y" }}>
      <div className="d-flex w-100 overflow-hidden">
        <motion.div 
          className="d-flex gap-3"
          initial={{ x: 0 }}
          animate={{ x: "-33.333333%" }}
          transition={{ 
            duration: speed, 
            ease: "linear", 
            repeat: Infinity,
            repeatType: "loop"
          }}
          style={{ width: "fit-content" }}
        >
          {/* Tripled set of images for seamless looping */}
          {[...images, ...images, ...images].map((image, index) => (
            <div 
              key={`${index}`} 
              className="flex-shrink-0 rounded-3 overflow-hidden shadow-sm"
              style={{ width: "400px", height: "280px" }}
            >
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="w-100 h-100 object-fit-cover d-block opacity-85"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.remove("opacity-85");
                  e.currentTarget.classList.add("opacity-100");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("opacity-100");
                  e.currentTarget.classList.add("opacity-85");
                }}
                loading="lazy"
                draggable={false}
              />
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
